import { useEffect, useState } from 'react';
import { useSelectWidgetConfigState } from 'widgets/store/configuration/hooks';
import { WidgetConfigWithTabTitle } from 'widgets/tabTitle/WidgetConfigWithTabTitle';
import { WidgetType } from 'widgets/WidgetType';
import { WidgetsService } from 'widgets/WidgetsService';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useServices } from 'app/hooks';
import { usePortfolioSelection } from 'portfolio/store/hooks';

export function useWidgetTabTitleOutsideContext(
    widgetsService: WidgetsService,
    widgetType: WidgetType,
    widgetKey: string,
    onSetTitle?: (title: string) => void
) {
    const selection = usePortfolioSelection();
    const config = useSelectWidgetConfigState<WidgetConfigWithTabTitle>(
        widgetType,
        widgetKey
    );

    useEffect(() => {
        if (onSetTitle) {
            widgetsService.getTitle(widgetType, selection, config).then((v) => {
                onSetTitle(v);
            });
        }
    }, [config, onSetTitle, widgetType, widgetsService, selection]);
}

export function useWidgetTitle() {
    const { widgetType, widgetKey } = useWidgetContext();
    const { widgetsService } = useServices();
    const selection = usePortfolioSelection();
    const config = useSelectWidgetConfigState<WidgetConfigWithTabTitle>(
        widgetType,
        widgetKey
    );

    const [title, setTitle] = useState('');

    useEffect(() => {
        widgetsService
            .getTitle(widgetType, selection, config)
            .then((v) => setTitle(v));
    }, [widgetsService, widgetType, selection, config]);

    return title;
}
